module.exports = __webpack_public_path__ + "img/h54img2.e83da72f.png";